"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterSensitiveData = filterSensitiveData;
const PARAM_NAMES = [
    'auth',
    'bearer',
    'credit',
    'CVD',
    'CVV',
    'encrypt',
    'PAN',
    'pass',
    'secret',
    'token',
];
const isSensitive = new RegExp(PARAM_NAMES.join('|'), 'i');
const isObject = (obj) => typeof obj === 'object' && !Array.isArray(obj) && obj !== null;
function filterSensitiveData(input, maxDepth = 3, currentDepth = 1, replaceWith = '[FILTERED]') {
    const filtered = {};
    for (const prop in input) {
        if (isSensitive.test(prop)) {
            filtered[prop] = replaceWith;
        }
        else {
            if (isObject(input[prop])) {
                if (currentDepth <= maxDepth) {
                    filtered[prop] = filterSensitiveData(input[prop], maxDepth, currentDepth + 1);
                }
                else {
                    filtered[prop] = '[object Object]';
                }
            }
            else {
                filtered[prop] = input[prop];
            }
        }
    }
    return filtered;
}
//# sourceMappingURL=filter-sensitive-data.js.map